import React, { useState } from 'react';
import './Tabs.scss';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { connect } from 'unistore/full/react';

export default connect(['isPremium'])(({ isPremium }) => {
  const history = useHistory();

  const isHomeTabActive = useRouteMatch('/home');
  const isSearchTabActive = useRouteMatch('/search/:section?/:searchString?');
  const isYourLibraryTabActive = useRouteMatch(
    '/:section(playlists|stations|)'
  );

  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 375 84"
        className="Tabs"
      >
        <path fill="#282828" d="M0 0H375V84H0z"></path>

        <g
          pointerEvents="bounding-box"
          onClick={() => history.push('/home')}
          transform={`translate(${isPremium ? 0 : -17}, 0)`}
        >
          <rect
            fill="#000"
            width="80"
            height="50"
            x="22"
            y="0"
            fillOpacity="0.001"
          />
          <text
            fill={isHomeTabActive ? '#fff' : '#B3B3B3'}
            xmlSpace="preserve"
            style={{ whiteSpace: 'pre' }}
            fontSize="11"
            fontWeight="450"
            letterSpacing="0em"
          >
            <tspan x="48.052" y="43.602">
              Home
            </tspan>
          </text>

          <g>
            {isHomeTabActive ? (
              <path
                fill="#fff"
                d="M72 28V13.174l-9.001-5.195L54 13.214V28h7v-7h4v7h7z"
              ></path>
            ) : (
              <path
                fill="#B3B3B3"
                d="M60 20h6v7h5V13.8l-8-4.6-8 4.6V27h5v-7zm1 8h-7V13.2L63 8l9 5.2V28h-7v-7h-4v7z"
              ></path>
            )}
          </g>
        </g>

        <g
          pointerEvents="bounding-box"
          onClick={() => history.push('/search')}
          transform={`translate(${isPremium ? 0 : -47}, 0)`}
        >
          <rect
            fill="#000"
            width="80"
            height="50"
            x="148"
            y="0"
            fillOpacity="0.001"
          />
          <text
            fill={isSearchTabActive ? '#fff' : '#B3B3B3'}
            xmlSpace="preserve"
            style={{ whiteSpace: 'pre' }}
            fontSize="11"
            fontWeight="450"
            letterSpacing="0em"
          >
            <tspan x="171.361" y="43.602">
              Search
            </tspan>
          </text>

          <g>
            {isSearchTabActive ? (
              <path
                fill="#fff"
                d="M193.166 22.244A8.216 8.216 0 00195.5 16.5a8.25 8.25 0 10-8.25 8.25c1.781 0 3.428-.57 4.776-1.532l4.625 5.416 1.141-.975-4.626-5.415zm-5.916 1.006a6.759 6.759 0 01-6.75-6.75 6.759 6.759 0 016.75-6.75A6.759 6.759 0 01194 16.5a6.758 6.758 0 01-6.75 6.75z"
              ></path>
            ) : (
              <path
                fill="#B3B3B3"
                d="M192.895 22.505A8.213 8.213 0 00195.5 16.5a8.25 8.25 0 10-8.25 8.25c1.917 0 3.676-.66 5.077-1.756l4.609 5.396.57-.486-4.611-5.4zM187.25 24c-4.136 0-7.5-3.364-7.5-7.5s3.364-7.5 7.5-7.5c4.135 0 7.5 3.364 7.5 7.5s-3.364 7.5-7.5 7.5z"
              ></path>
            )}
          </g>
        </g>

        <g
          pointerEvents="bounding-box"
          onClick={() => history.push('/')}
          transform={`translate(${isPremium ? 0 : -78}, 0)`}
        >
          <rect
            fill="#000"
            width="80"
            height="50"
            x="274"
            y="0"
            fillOpacity="0.001"
          />
          <text
            fill={isYourLibraryTabActive ? '#fff' : '#B3B3B3'}
            xmlSpace="preserve"
            style={{ whiteSpace: 'pre' }}
            fontSize="11"
            fontWeight="450"
            letterSpacing="0em"
          >
            <tspan x="283.126" y="43.602">
              Your Library
            </tspan>
          </text>
          <g>
            {isYourLibraryTabActive ? (
              <path
                fill="#fff"
                d="M315.617 9.893l-1.827.814 7.797 17.513 1.827-.813-7.797-17.514zM304 28h2V10h-2v18zm5 0h2V10h-2v18z"
              ></path>
            ) : (
              <path
                fill="#B3B3B3"
                d="M314.66 10.097l-.913.406 7.797 17.513.914-.406-7.798-17.513zM304 28h1V10h-1v18zm6 0h1V10h-1v18z"
              ></path>
            )}
          </g>
        </g>

        {!isPremium && (
          <g transform="translate(282, 0)">
            <text
              fill="#B3B3B3"
              style={{ whiteSpace: 'pre' }}
              fontSize="11"
              letterSpacing="0em"
            >
              <tspan x="25.227" y="43.602">
                Premium
              </tspan>
            </text>
            <path
              fill="#B3B3B3"
              d="M46.754 7c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11-4.925-11-11-11zm5.366 15.857a.955.955 0 01-1.302.367 11.409 11.409 0 00-4.451-1.402 11.443 11.443 0 00-4.653.482.957.957 0 01-.582-1.823 13.32 13.32 0 015.429-.563c1.843.188 3.59.738 5.193 1.636.46.259.624.842.366 1.303zm1.318-3.341a.957.957 0 01-1.29.407 14.965 14.965 0 00-5.423-1.618 14.887 14.887 0 00-5.675.505.958.958 0 01-.53-1.838 16.847 16.847 0 016.398-.571c2.153.219 4.21.833 6.114 1.825.468.244.65.822.406 1.29zm.476-2.779a.957.957 0 01-.426-.1 18.475 18.475 0 00-6.406-1.849 18.472 18.472 0 00-6.66.526.958.958 0 01-.494-1.849 20.386 20.386 0 017.346-.581c2.478.251 4.856.938 7.066 2.04a.956.956 0 01-.426 1.813z"
            ></path>
          </g>
        )}
      </svg>
    </>
  );
});

// <svg
//   xmlns="http://www.w3.org/2000/svg"
//   width="375"
//   height="49"
//   fill="none"
//   viewBox="0 0 375 49"
// >
//   <path fill="#282828" d="M0 0H375V49H0z"></path>
//   <text
//     fill="#B3B3B3"
//     style={{ whiteSpace: 'pre' }}
//     fontFamily="Circular Sp UI"
//     fontSize="11"
//     letterSpacing="0em"
//   >
//     <tspan x="307.227" y="43.602">
//       Premium
//     </tspan>
//   </text>
//   <path
//     fill="#B3B3B3"
//     d="M328.754 7c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11-4.925-11-11-11zm5.366 15.857a.955.955 0 01-1.302.367 11.409 11.409 0 00-4.451-1.402 11.443 11.443 0 00-4.653.482.957.957 0 01-.582-1.823 13.32 13.32 0 015.429-.563c1.843.188 3.59.738 5.193 1.636.46.259.624.842.366 1.303zm1.318-3.341a.957.957 0 01-1.29.407 14.965 14.965 0 00-5.423-1.618 14.887 14.887 0 00-5.675.505.958.958 0 01-.53-1.838 16.847 16.847 0 016.398-.571c2.153.219 4.21.833 6.114 1.825.468.244.65.822.406 1.29zm.476-2.779a.957.957 0 01-.426-.1 18.475 18.475 0 00-6.406-1.849 18.472 18.472 0 00-6.66.526.958.958 0 01-.494-1.849 20.386 20.386 0 017.346-.581c2.478.251 4.856.938 7.066 2.04a.956.956 0 01-.426 1.813z"
//   ></path>
//   <text
//     fill="#B3B3B3"
//     style={{ whiteSpace: 'pre' }}
//     fontFamily="Circular Sp UI"
//     fontSize="11"
//     letterSpacing="0em"
//   >
//     <tspan x="204.629" y="43.602">
//       Your Library
//     </tspan>
//   </text>
//   <path
//     fill="#B3B3B3"
//     d="M236.163 10.097l-.913.406 7.797 17.513.914-.406-7.798-17.513zM225.503 28h1V10h-1v18zm6 0h1V10h-1v18z"
//   ></path>
//   <text
//     fill="#B3B3B3"
//     style={{ whiteSpace: 'pre' }}
//     fontFamily="Circular Sp UI"
//     fontSize="11"
//     letterSpacing="0em"
//   >
//     <tspan x="123.612" y="43.602">
//       Search
//     </tspan>
//   </text>
//   <path
//     fill="#B3B3B3"
//     d="M144.638 22.623a8.47 8.47 0 002.613-6.123 8.5 8.5 0 10-8.5 8.5 8.454 8.454 0 005.125-1.73l4.401 5.153.76-.649-4.399-5.151zM138.751 24c-4.136 0-7.5-3.364-7.5-7.5s3.364-7.5 7.5-7.5 7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5z"
//   ></path>
//   <text
//     fill="#fff"
//     style={{ whiteSpace: 'pre' }}
//     fontFamily="Circular Sp UI"
//     fontSize="11"
//     letterSpacing="0em"
//   >
//     <tspan x="31.052" y="43.602">
//       Home
//     </tspan>
//   </text>
//   <path
//     fill="#fff"
//     d="M55 28V13.174l-9.001-5.195L37 13.214V28h7v-7h4v7h7z"
//   ></path>
// </svg>;
